'use strict';


'kiwi public';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _TextFormatting = require('@/helpers/TextFormatting');

var TextFormatting = _interopRequireWildcard(_TextFormatting);

var _Misc = require('@/helpers/Misc');

var Misc = _interopRequireWildcard(_Misc);

var _state = require('@/libs/state');

var _state2 = _interopRequireDefault(_state);

var _IPC = require('@/libs/IPC');

var _IPC2 = _interopRequireDefault(_IPC);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var firstRun = true;

exports.default = {
    data: function data() {
        return {
            hasOtherTab: false,
            addedNetworkToExisting: false,
            server: null,
            readyToShowOptions: false
        };
    },
    computed: {
        networks: function networks() {
            return _state2.default.networks;
        },
        hasFragment: function hasFragment() {
            return window.location.hash && window.location.hash.length > 1;
        }
    },
    created: function created() {
        var _this = this;

        this.$state.setting('allowRegisterProtocolHandler', true);

        var server = null;
        if (this.hasFragment) {
            server = this.parseFragment();
            this.server = server;
        }

        if (server) {
            this.findOtherTabs().then(function (hasOtherTab) {
                if (hasOtherTab) {
                    _this.hasOtherTab = true;
                } else {
                    _this.listenForOtherTabs();
                    _this.init();
                }

                _this.readyToShowOptions = true;
            });
        } else {
            this.listenForOtherTabs();
            this.init();
        }
    },
    methods: {
        listenForOtherTabs: function listenForOtherTabs() {
            var _this2 = this;

            _IPC2.default.on('message', function (e) {
                var msg = e.data;
                if (msg.type === 'ping' && _this2.networks.length > 0) {
                    _IPC2.default.send({ type: 'pong' });
                } else if (msg.type === 'addNetwork') {
                    var network = _this2.networks.find(function (n) {
                        return n.name === msg.server;
                    });
                    if (!network) {
                        network = _state2.default.addNetwork(msg.server, msg.nick || 'Guest' + Math.floor(Math.random() * 100), msg);
                    }
                    network.showServerBuffer('settings');
                }
            });
        },
        addEmptyNetwork: function addEmptyNetwork() {
            var nick = 'Guest' + Math.floor(Math.random() * 100);
            var network = _state2.default.addNetwork(TextFormatting.t('new_network'), nick, {});
            network.showServerBuffer('settings');
        },
        findOtherTabs: function findOtherTabs() {
            var _this3 = this;

            return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
                return _regenerator2.default.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                return _context.abrupt('return', new _promise2.default(function (resolve, reject) {
                                    var handleIPCMessage = function handleIPCMessage(e) {
                                        var msg = e.data;
                                        if (msg.type === 'pong') {
                                            clearTimeout(timer);
                                            resolve(true);
                                        }
                                    };

                                    var timer = setTimeout(function (e) {
                                        _IPC2.default.removeListener('message', handleIPCMessage);
                                        resolve(false);
                                    }, 200);

                                    _IPC2.default.on('message', handleIPCMessage);
                                    _IPC2.default.send({ type: 'ping' });
                                }));

                            case 1:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this3);
            }))();
        },
        addNetworkToExistingTab: function addNetworkToExistingTab() {
            var nick = 'Guest' + Math.floor(Math.random() * 100);
            var con = this.server;

            _state2.default.addNetwork(TextFormatting.t('new_network'), nick, {});

            _IPC2.default.send({
                nick: nick,
                server: con.server,
                port: con.port,
                tls: con.tls,
                password: con.password || '',
                type: 'addNetwork'
            });

            window.location.hash = '';

            this.addedNetworkToExisting = true;
        },
        addNetwork: function addNetwork() {
            var temporary = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

            if (!this.server) {
                return;
            }

            var con = this.server;

            if (temporary) {
                _state2.default.persistence.storageKey = null;
                _state2.default.persistence.forgetState();

                this.init();
            }

            var network = _state2.default.getNetworkFromAddress(con.server);
            if (!network) {
                network = _state2.default.addNetwork(con.server, con.nick || 'Guest' + Math.floor(Math.random() * 100), {
                    server: con.server,
                    port: con.port,
                    tls: con.tls,
                    password: con.password || ''
                });
            }

            window.location.hash = '';
            network.showServerBuffer('settings');

            this.$emit('start', {
                fallbackComponent: this.constructor
            });
        },
        parseFragment: function parseFragment() {
            if (window.location.hash.substr(1)) {
                var fragment = window.location.hash.substr(1);

                var uriCheck = fragment.substr(0, 7).toLowerCase();
                if (uriCheck === 'ircs%3a' || uriCheck.substr(0, 6) === 'irc%3a') {
                    fragment = decodeURIComponent(fragment);
                }

                var connections = Misc.parseIrcUri(fragment);
                var con = connections[0];
                return con;
            }
            return null;
        },
        toggleStateBrowser: function toggleStateBrowser() {
            _state2.default.$emit('statebrowser.show');
        },
        init: function init() {
            var _this4 = this;

            return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2() {
                var persistSetting;
                return _regenerator2.default.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                if (firstRun) {
                                    _context2.next = 2;
                                    break;
                                }

                                return _context2.abrupt('return');

                            case 2:

                                firstRun = false;

                                persistSetting = _state2.default.settings.startupOptions.remember_buffers;

                                if (typeof persistSetting === 'undefined') {
                                    _state2.default.persistence.includeBuffers = true;
                                } else {
                                    _state2.default.persistence.includeBuffers = !!persistSetting;
                                }

                                _state2.default.persistence.watchStateForChanges();

                                _state2.default.setSetting('settings.restricted', false);

                                _this4.$emit('start', {
                                    fallbackComponent: _this4.constructor
                                });

                            case 8:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, _this4);
            }))();
        }
    }
};
window._kiwi_exports = window._kiwi_exports || {};
if(!window._kiwi_exports["components"]) window._kiwi_exports["components"] = {};
if(!window._kiwi_exports["components"]["startups"]) window._kiwi_exports["components"]["startups"] = {};
window._kiwi_exports["components"]["startups"]["Personal"]
window._kiwi_exports.components.startups.Personal = exports.default ? exports.default : exports;



//////////////////
// WEBPACK FOOTER
// ./build/exports-loader.js!./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/startups/Personal.vue
// module id = 3EQ1
// module chunks = 1